import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getReceivedInterests,
  respondToInterest,
} from "../../store/slices/intrestandshortlisted";
import { Container } from "react-bootstrap";

function scoreColor(score) {
  if (score >= 90) return { bg: "#fef9ec", border: "#f5c842", text: "#b07820" };
  if (score >= 80) return { bg: "#f0fdf4", border: "#86efac", text: "#16a34a" };
  return { bg: "#fdf6f0", border: "#f0c0a0", text: "#b05020" };
}

export default function Interests() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { receivedInterests = [], loading = false } = useSelector(
    (state) => state.interestShortlist || {},
  );

  const interestsData = receivedInterests || [];

  useEffect(() => {
    dispatch(getReceivedInterests({}));
  }, [dispatch]);

  const [activeTab, setActiveTab] = useState("received");

  const [sortBy, setSortBy] = useState("newest");

  const pendingCount = interestsData.filter(
    (p) => p.status === "pending",
  ).length;

  const acceptedCount = interestsData.filter(
    (p) => p.status === "accepted",
  ).length;

  const declinedCount = interestsData.filter(
    (p) => p.status === "rejected",
  ).length;
  const newCount = interestsData.filter((p) => p.isNew).length;

  const tabData = {
    received: interestsData,
    accepted: interestsData.filter((p) => p.status === "accepted"),
    declined: interestsData.filter((p) => p.status === "rejected"),
  };

  const visibleProfiles = tabData[activeTab] ?? [];

  const handleRespond = async (interestId, action) => {
    try {
      await dispatch(
        respondToInterest({
          interestId,
          action, // "accepted" or "rejected"
        }),
      ).unwrap();
      // refresh list
      dispatch(getReceivedInterests({}));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Container fluid>
        <div className="ip-root">
          <div className="ip-page-header">
            <div className="ip-title">
              Interested Profiles <span className="ip-title-accent">✦</span>
            </div>
            <div className="ip-subtitle">
              Profiles that have expressed interest in connecting with you
            </div>
          </div>

       
          {loading ? (
            <div className="summary-banner">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="summary-item">
                  <div className="ep-skeleton-title" style={{ width: 40, marginBottom: 6 }} />
                  <div className="ep-skeleton-line short" style={{ width: 70 }} />
                </div>
              ))}
            </div>
          ) : (
            <div className="summary-banner">
              {[
                { num: interestsData.length, label: "Total Interests" },
                { num: pendingCount, label: "Awaiting Response" },
                { num: acceptedCount, label: "Accepted" },
                { num: newCount, label: "New Today" },
              ].map(({ num, label }) => (
                <div key={label} className="summary-item">
                  <div className="summary-num">{num}</div>
                  <div className="summary-label">{label}</div>
                </div>
              ))}
            </div>
          )}

          <div className="ip-tabs">
            {[
              { key: "received", label: "All Received", count: interestsData.length },
              { key: "accepted", label: "Accepted", count: acceptedCount },
              { key: "declined", label: "Declined", count: declinedCount },
            ].map((tab) => (
              <button
                key={tab.key}
                className={`ip-tab${activeTab === tab.key ? " active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
                <span className="tab-count">{tab.count}</span>
              </button>
            ))}
          </div>

          <div className="ip-toolbar">
            <div className="ip-result-count">
              Showing <strong>{visibleProfiles.length}</strong> profile
              {visibleProfiles.length !== 1 ? "s" : ""}
            </div>
            <div className="ip-sort">
              Sort by
              <select
                className="ip-sort-select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="newest">Newest First</option>
                <option value="match">Match Score</option>
                <option value="age">Age</option>
              </select>
            </div>
          </div>

          <div className="ip-grid">
            {loading ? (
              
              [1, 2, 3, 4].map((i) => (
                <div key={i} className="ep-skeleton-card icard">
                  {/* Photo area */}
                  <div className="icard-photo">
                    <div className="ep-skeleton-square" style={{width:"100%"}} />
                  </div>

                  {/* Body area */}
                  <div className="icard-body">
                    <div className="icard-top">
                      <div style={{ flex: 1 }}>
                        <div className="ep-skeleton-title" />
                        <div className="ep-skeleton-line short" style={{ marginTop: 6 }} />
                      </div>
                      <div className="icard-time" style={{ marginLeft: 14 }}>
                        <div className="ep-skeleton-line" style={{ width: 60 }} />
                        <div className="ep-skeleton-line short" style={{ width: 50, marginTop: 4 }} />
                      </div>
                    </div>

                    {/* Chips */}
                    <div className="icard-chips" style={{ marginTop: 10, display: "flex", gap: 8 }}>
                      <div className="ep-skeleton-line" style={{ width: 80, borderRadius: 20 }} />
                      <div className="ep-skeleton-line" style={{ width: 90, borderRadius: 20 }} />
                      <div className="ep-skeleton-line" style={{ width: 70, borderRadius: 20 }} />
                    </div>

                    {/* Action buttons */}
                    <div className="icard-actions" style={{ marginTop: 12, display: "flex", gap: 8 }}>
                      <div className="ep-skeleton-line" style={{ width: 80, height: 32, borderRadius: 6 }} />
                      <div className="ep-skeleton-line" style={{ width: 80, height: 32, borderRadius: 6 }} />
                      <div className="ep-skeleton-line" style={{ width: 100, height: 32, borderRadius: 6 }} />
                      <div className="ep-skeleton-circle" style={{ width: 32, height: 32 }} />
                    </div>
                  </div>
                </div>
              ))
            ) : visibleProfiles.length === 0 ? (
              <div className="empty-wrap">
                <div className="empty-icon">
                  {activeTab === "accepted" ? "✓" : activeTab === "declined" ? "✕" : "💌"}
                </div>
                <div className="empty-title">
                  {activeTab === "accepted"
                    ? "No accepted interests yet"
                    : activeTab === "declined"
                      ? "No declined interests"
                      : "No interests received yet"}
                </div>
                <div className="empty-text">
                  {activeTab === "received"
                    ? "When someone expresses interest in your profile, it will appear here."
                    : "Profiles you've responded to will show here."}
                </div>
              </div>
            ) : (
              visibleProfiles.map((profile) => {
                const sc = scoreColor(profile.matchScore);
                const status = profile.status;
                return (
                  <div
                    key={profile.interestId}
                    className={`icard${profile.isNew && status === "pending" ? " new-interest" : ""}`}
                  >
                    {profile.isNew && status === "pending" && (
                      <div className="new-badge">✦ New</div>
                    )}

                    <div className="icard-photo">
                      <img
                        src={profile?.user?.profilePhoto}
                        alt={profile?.user?.name}
                      />
                      {profile.online && (
                        <div className="icard-online">● Online</div>
                      )}
                      {profile.verified && (
                        <div className="icard-verified">✓ Verified</div>
                      )}
                    </div>

                    <div className="icard-body">
                      <div className="icard-top">
                        <div style={{ flex: 1 }}>
                          <div className="icard-name">{profile?.user?.name}</div>
                          <div className="icard-meta">
                            {profile?.user?.age} yrs · {profile.height} ·{" "}
                            {profile.maritalStatus}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        />

                        <div className="icard-time" style={{ marginLeft: 14 }}>
                          <div className="icard-time-label">Received</div>
                          <div className="icard-time-val">{profile.receivedOn}</div>
                        </div>
                      </div>

                      <div className="icard-chips">
                        <span className="chip">🎓&nbsp; {profile.education}</span>
                        <span className="chip">💼&nbsp; {profile.occupation}</span>
                        <span className="chip">📍&nbsp; {profile.city}</span>
                      </div>

                      <div className="icard-actions">
                        {status === "pending" && (
                          <>
                            <button
                              className="btn-accept"
                              onClick={() => handleRespond(profile.interestId, "accepted")}
                            >
                              ✓ Accept
                            </button>
                            <button
                              className="btn-decline"
                              onClick={() => handleRespond(profile.interestId, "rejected")}
                            >
                              ✕ Decline
                            </button>
                          </>
                        )}

                        {status === "accepted" && (
                          <>
                            <span className="status-accepted">✓ Interest Accepted</span>
                            <button
                              className="btn-decline"
                              style={{ fontSize: 12, padding: "6px 12px" }}
                            >
                              Undo
                            </button>
                          </>
                        )}

                        {status === "declined" && (
                          <>
                            <span className="status-declined">✕ Declined</span>
                            <button
                              className="btn-view"
                              style={{ fontSize: 12, padding: "6px 12px" }}
                            >
                              Undo
                            </button>
                          </>
                        )}

                        <button
                          className="btn-view"
                          onClick={() => navigate(`/user/profile-details/${profile?.user?._id}`)}
                        >
                          View Profile
                        </button>

                        <button className="btn-msg" title="Send Message">
                          💬
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </Container>
    </>
  );
}
